<template>
  <header>
    <div class="top">
      <div class="brand">
        <span @click="goToHome()">geekchic</span>
      </div>
      <!-- <div class="menu">
        <span>Menu</span>
      </div> -->
    </div>
    <div class="bottom">
      <div class="wrapper">
        <h1>Chuyên order hàng nguyên liệu hãng</h1>
        <div class="filter">
          <img
            src="@/assets/icons/search-status.png"
            alt=""
            height="25px"
            @click="handleFilterProducts()"
          />
          <input
            v-model="filter.name"
            type="text"
            name="keyword"
            placeholder="Nhập tên hoặc mã sản phẩm cần tìm"
            @keyup.enter="handleFilterProducts()"
          />

          <AppSecondaryButton
            caption="Tìm kiếm"
            @onClick="handleFilterProducts()"
          />

          <AppSecondaryButton
            caption="Bộ lọc sản phẩm"
            :icon="require(`@/assets/icons/candle-2.png`)"
            @onClick="openModal()"
          />
        </div>
        <div class="scroller" v-if="categories.length">
          <!-- <div class="all" @click="filterCategory()" ref="all">
            <img src="@/assets/icons/bolt.svg" alt="" />
            All sản phẩm
          </div> -->
          <div class="position-relative">
            <div class="paddle left">
              <img
                v-if="scrollPosition > 0"
                src="@/assets/icons/right-svgrepo-com.svg"
                alt=""
                width="20"
                height="20"
                @click.stop="scroll($refs.categories, 'left')"
              />
            </div>
            <div class="paddle right">
              <img
                v-if="SHOW_RIGHT_SCROLLING"
                src="@/assets/icons/right-svgrepo-com.svg"
                alt=""
                width="20"
                height="20"
                @click.stop="scroll($refs.categories)"
              />
            </div>
            <div class="categories" ref="categories">
              <div
                class="category"
                v-for="m in menu"
                :key="m.key"
                @click.self="filterCategory($event, m)"
              >
                <span @click.stop="$event.target.parentElement.click()">{{
                  m.name
                }}</span>
                <div v-if="m.children" class="carpet-down">
                  <img
                    @click.stop="show($event)"
                    src="@/assets/icons/down-svgrepo-com.svg"
                    alt=""
                    width="10"
                    height="10"
                  />
                </div>
                <div class="sub" ref="subs">
                  <ul v-if="m.children">
                    <li
                      v-for="(c, index) in m.children"
                      :key="'child-' + index"
                    >
                      <AppAccordion
                        :configs="c"
                        @selected="onMenuSelected($event)"
                      >
                        <template v-if="c.children">
                          <AppAccordion
                            v-for="sc in c.children"
                            :key="sc.key"
                            :configs="sc"
                            @selected="onMenuSelected($event)"
                          ></AppAccordion>
                        </template>
                      </AppAccordion>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <dialog ref="dialog">
        <div class="dialog-header">
          <h4>Lọc Sản Phẩm</h4>
          <img
            src="@/assets/icons/times-svgrepo-com.svg"
            alt=""
            @click="closeModal()"
          />
        </div>
        <div class="dialog-body">
          <div class="accordion" id="accordionFilter">
            <div class="accordion-item" v-if="brands.length">
              <h2 class="accordion-header" id="headingBrand">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseBrand"
                  aria-expanded="true"
                  aria-controls="collapseBrand"
                >
                  Thương hiệu
                </button>
              </h2>
              <div
                id="collapseBrand"
                class="accordion-collapse collapse show"
                aria-labelledby="headingBrand"
                data-bs-parent="#accordionFilter"
              >
                <!-- "key" is a reserved attribute and cannot be used as component prop. -->
                <div class="accordion-body">
                  <AppCheckBox
                    ref="checkboxes"
                    v-for="brand in brands"
                    :key="brand.id"
                    group="brand_id"
                    :keyi="brand.id"
                    :value="brand.name"
                    @onChecked="checked($event)"
                  />
                </div>
              </div>
            </div>
            <div class="accordion-item" v-if="groups.length">
              <h2 class="accordion-header" id="headingGroup">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseGroup"
                  aria-expanded="false"
                  aria-controls="collapseGroup"
                >
                  Nhóm
                </button>
              </h2>
              <div
                id="collapseGroup"
                class="accordion-collapse collapse"
                aria-labelledby="headingGroup"
                data-bs-parent="#accordionFilter"
              >
                <div class="accordion-body">
                  <AppCheckBox
                    ref="checkboxes"
                    v-for="group in groups"
                    :key="group.id"
                    :keyi="group.id"
                    group="group_id"
                    :value="group.name"
                    @onChecked="checked($event)"
                  />
                </div>
              </div>
            </div>
            <div class="accordion-item" v-if="genders.length">
              <h2 class="accordion-header" id="headingGender">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseGender"
                  aria-expanded="false"
                  aria-controls="collapseGender"
                >
                  Giới tính
                </button>
              </h2>
              <div
                id="collapseGender"
                class="accordion-collapse collapse"
                aria-labelledby="headingGender"
                data-bs-parent="#accordionFilter"
              >
                <div class="accordion-body">
                  <AppCheckBox
                    ref="checkboxes"
                    v-for="gender in genders"
                    :key="gender.id"
                    group="gender_id"
                    :keyi="gender.id"
                    :value="gender.name"
                    @onChecked="checked($event)"
                  />
                </div>
              </div>
            </div>
            <div class="accordion-item" v-if="states.length">
              <h2 class="accordion-header" id="headingState">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseState"
                  aria-expanded="false"
                  aria-controls="collapseState"
                >
                  Trạng thái
                </button>
              </h2>
              <div
                id="collapseState"
                class="accordion-collapse collapse"
                aria-labelledby="headingState"
                data-bs-parent="#accordionFilter"
              >
                <div class="accordion-body">
                  <AppCheckBox
                    ref="checkboxes"
                    v-for="state in states"
                    :key="state.id"
                    group="state_id"
                    :keyi="state.id"
                    :value="state.name"
                    @onChecked="checked($event)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-footer d-flex justify-content-center my-4">
          <div class="actions">
            <AppPrimaryButton
              caption="Áp Dụng"
              size="xl"
              @onClick="applyFilter()"
            />
          </div>
          <span @click="clearAll()"
            >Xóa Lọc <img src="@/assets/icons/times-svgrepo-com (1).svg" alt=""
          /></span>
        </div>
      </dialog>
    </div>
  </header>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("publicStoreModule");

import AppCheckBox from "@/views/front/components/CheckBox.vue";
import AppPrimaryButton from "@/views/front/components/PrimaryButton.vue";
import AppSecondaryButton from "@/views/front/components/SecondaryButton.vue";
import AppAccordion from "@/views/front/components/Accordion.vue";
export default {
  name: "Header",
  components: {
    AppCheckBox,
    AppPrimaryButton,
    AppSecondaryButton,
    AppAccordion,
  },
  data() {
    return {
      filter: {
        name: null,
        category_id: null,
        brand_id: null,
      },
      // menu: [
      //   {
      //     key: "grandparent1",
      //     name: "Sản phẩm",
      //     children: [
      //       {
      //         key: "parent1",
      //         name: "Nam",
      //         children: [
      //           {
      //             key: "child11",
      //             name: "Giày dép",
      //           },
      //           {
      //             key: "child12",
      //             name: "Phụ kiện nam",
      //           },
      //         ],
      //       },
      //       {
      //         key: "parent2",
      //         name: "Nữ",
      //         children: [
      //           {
      //             key: "child21",
      //             name: "Giày dép",
      //           },
      //           {
      //             key: "child22",
      //             name: "Phụ kiện nam",
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     key: "granparent2",
      //     name: "Hướng dẫn thanh toán",
      //   },
      //   {
      //     key: "granparent3",
      //     name: "Cách thức mua hàng",
      //   },
      //   {
      //     key: "granparent4",
      //     name: "Vận chuyển",
      //   },
      //   {
      //     key: "granparent5",
      //     name: "Jennierubyjane",
      //   },
      // ],
      checkedItems: [],
      scrollPosition: 0,
      PIXELS: 208, //categoty offsetwith is 200px + 8px of margin right
      SHOW_RIGHT_SCROLLING: true,
      DISABLE_LEFT_SCROLLING: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getMenu();
    this.getCategories();
    this.getBrands();
    this.getGroups();

    setTimeout(() => {
      const menus = this.$refs.categories;
      if(menus) menus.childNodes[0].classList.add('active');
    }, 500);
  },
  methods: {
    ...mapActions(["getMenu", "getCategoryContent", "getCategories", "getBrands", "getGroups", "getProducts"]),
    getIconUrl(category) {
      return category.icon
        ? `${category.base_url}${category.icon.url}`
        : "@/assets/icons/category_default.png";
    },

    filterCategory(e, m) {
      // document.querySelector("title").innerText = category
      //   ? category.name + " | geekchic"
      //   : "Home | geekchic";

      const categories = this.$refs.categories;

      categories.childNodes.forEach((el) => {
        if (el == e.target) {
          el.classList.add("active");
        } else el.classList.remove("active");
      });

      if (m.type == 1) {
        this.filter = null;
        this.handleFilterProducts();
      } else if (m.type == 0) {
        this.$router.push({ name: "front.category.detail", params: { key: m.key, query: m.query }}).catch(() => {});
        this.getCategoryContent(m.query);
      }
    },

    handleFilterProducts() {
      const params = { filter: this.filter, page: 1 };
      this.getProducts(params);
      this.$router.push({ name: "front.home" }).catch(() => {});
    },

    openModal() {
      const modal = this.$refs.dialog;
      modal.showModal();
    },

    closeModal() {
      const modal = this.$refs.dialog;
      modal.classList.add("hide");

      let coolFunction = () => {
        modal.classList.remove("hide");
        modal.close();
        modal.removeEventListener("webkitAnimationEnd", coolFunction);
      };

      modal.addEventListener("webkitAnimationEnd", coolFunction);
    },

    checked(e) {
      const group = Object.keys(e)[0];
      const member = e[group];
      if (member.checked === false) {
        const index = this.checkedItems[group].findIndex(
          (item) => item.key === member.key
        );
        if (index !== -1) this.checkedItems[group].splice(index, 1);
        return;
      }

      const hasGroup = this.checkedItems[group];
      if (hasGroup) this.checkedItems[group].push(member);
      else this.checkedItems[group] = [member];
    },

    clearAll() {
      Object.keys(this.checkedItems).forEach(
        (group) => (this.checkedItems[group] = [])
      );
      const checkboxes = this.$refs.checkboxes;
      checkboxes.forEach((checkbox) => checkbox.unCheck());

      // alert(JSON.stringify(this.checkedItems))
    },

    applyFilter() {
      const groups = Object.keys(this.checkedItems);

      const filters = [];
      groups.forEach((group) => {
        filters.push({
          [group]: this.checkedItems[group].map((x) => x.id),
        });
      });

      // alert(JSON.stringify(filters));
      const params = { filter: filters, page: 1 };
      this.getProducts(params);
      this.closeModal();
    },

    scroll(container, direction = "right") {
      if (!container) return;
      this.hideDropdown();
      const offsetWidth = this.PIXELS * this.categories.length;
      if (direction === "left") {
        if (this.scrollPosition <= 0) return;
        this.scrollPosition = this.scrollPosition - this.PIXELS;
      } else {
        if (this.scrollPosition >= offsetWidth) return;
        this.scrollPosition = this.scrollPosition + this.PIXELS;
      }

      this.handleScrollingPaddle(this.scrollPosition);

      const subs = this.$refs.subs;
      subs.forEach((item) => {
        const ul = item.querySelector("ul");
        if (!ul) return;

        const offsets = ul.getBoundingClientRect();

        if (direction === "right")
          ul.style.left = offsets.left - this.PIXELS + "px";
        else ul.style.left = offsets.left + this.PIXELS + "px";
      });

      container.scrollTo({
        left: this.scrollPosition,
        behavior: "smooth",
      });
    },

    handleScrollingPaddle(scrollingPosition) {
      const innerWith = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      );
      switch (
        innerWith <= 480
          ? "480 - true"
          : innerWith <= 768
          ? "768 - true"
          : innerWith <= 1279
          ? "1279 - true"
          : innerWith <= 1660
          ? "1279 - false"
          : "default"
      ) {
        case "480 - true":
          Math.round(scrollingPosition / this.PIXELS) + 1 >= this.menu.length
            ? (this.SHOW_RIGHT_SCROLLING = false)
            : (this.SHOW_RIGHT_SCROLLING = true);
          break;
        case "768 - true":
          Math.round(scrollingPosition / this.PIXELS) + 2 >= this.menu.length
            ? (this.SHOW_RIGHT_SCROLLING = false)
            : (this.SHOW_RIGHT_SCROLLING = true);
          break;
        case "1279 - true":
          Math.round(scrollingPosition / this.PIXELS) + 3 >= this.menu.length
            ? (this.SHOW_RIGHT_SCROLLING = false)
            : (this.SHOW_RIGHT_SCROLLING = true);
          break;
        case "1660 - true":
          Math.round(scrollingPosition / this.PIXELS) + 5 >= this.menu.length
            ? (this.SHOW_RIGHT_SCROLLING = false)
            : (this.SHOW_RIGHT_SCROLLING = true);
          break;
        case "default":
          Math.round(scrollingPosition / this.PIXELS) + 6 >= this.menu.length
            ? (this.SHOW_RIGHT_SCROLLING = false)
            : (this.SHOW_RIGHT_SCROLLING = true);
          break;
        default:
          break;
      }
    },

    show(e) {
      const el = e.target;
      const parent = el.parentElement;
      const subMenu = parent.nextSibling;
      if (subMenu.classList.contains("active")) {
        subMenu.classList.remove("active");
        return;
      }
      this.hideDropdown();

      subMenu.classList.add("active");
    },

    hideDropdown() {
      if (!this.$refs.categories) return;
      const categories = this.$refs.categories.childNodes;

      categories.forEach((item) => {
        const sub = item.querySelector(".sub");
        sub.classList.remove("active");
      });
    },

    foo(el) {
      const grandGrandParent = el.parentElement.parentElement.parentElement;
      grandGrandParent.querySelector("span").innerText = el.innerText;

      const grandParent = el.parentElement.parentElement;
      grandParent.classList.remove("active");
    },

    handleScroll() {
      this.hideDropdown();
      if (!this.$refs.subs) return;
      const subs = this.$refs.subs;
      const scrollY = window.scrollY;

      setTimeout(() => {
        const INITIAL_POSITION =
          this.$refs.categories.getBoundingClientRect().top +
          document.documentElement.scrollTop +
          46; //menu height

        subs.forEach((item) => {
          const ul = item.querySelector("ul");
          if (!ul) return;
          ul.style.top = INITIAL_POSITION - scrollY + "px"; //397 initial position
        });
      }, 200);
    },

    onMenuSelected(e) {
      this.hideDropdown();
      // alert(e);
      this.filter = null;
      this.handleFilterProducts();
    },

    goToHome() {
      this.$router.push("/home");
    },
  },
  computed: {
    ...mapState(["menu", "categoryContent", "categories", "brands", "groups", "genders", "states"]),
  },
};
</script>
<style scoped lang="scss">
header {
  .top {
    box-sizing: border-box;
    max-width: 1440px;
    height: 114px;
    background-color: #fff;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .brand {
      span {
        cursor: pointer;
        font-size: 48px;
        color: #000;
        font-weight: bold;
        font-family: "Dela Gothic One", cursive;
      }
    }
    .menu {
      span {
        font-size: 16px;
        font-weight: bolder;
        font-family: "Dela Gothic One", cursive;
        color: #000;
      }
    }
  }
  .bottom {
    background-color: #000;
    height: 330px;
    .wrapper {
      max-width: 1440px;
      margin: 0 auto;
      padding: 49px 0 39px 0;
      h1 {
        // width: 289px;
        color: #fff;
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 35px;
      }
      .filter {
        display: flex;
        position: relative;
        > img {
          cursor: pointer;
          position: absolute;
          left: 38px;
          top: 50%;
          transform: translate(-50%, -14px);
        }
        input {
          width: 380px;
          height: 55px;
          border-radius: 10px;
          background-color: #303030;
          padding-left: 88px;
          color: #fff;
          outline: none;
          border: none;
          margin-right: 10px;
          &::placeholder {
            color: #c1c0c0;
          }
        }
      }
      .scroller {
        margin-top: 40px;
        display: flex;
        align-items: center;
        .all {
          cursor: pointer;
          background-color: #d9d9d91a;
          border-radius: 10px;
          color: #fff;
          padding: 16px 26px;
          &.active {
            background-color: #3b664a;
          }
          img {
            width: 24px;
            height: auto;
            margin-right: 14px;
          }
        }
        .divider {
          border-left: 1px solid #fff;
          height: 20px;
          margin: 0 25px;
        }
        .paddle {
          display: none;
          position: absolute;
          width: 20px;
          top: 50%;
          transform: translate(-50%, -50%);
          img {
            cursor: pointer;
          }
          &.left {
            left: -12px;
            img {
              transform: rotate(180deg) !important;
            }
          }
          &.right {
            right: -36px;
          }
        }
        .categories {
          display: flex;
          max-width: 1040px;
          overflow: hidden;
          position: relative;
          .category {
            min-width: 200px;
            cursor: pointer;
            margin-right: 8px;
            padding: 5px 22px 5px 8px;
            border-radius: 23px;
            background-color: #8f8f8f1a;
            display: flex;
            align-items: center;
            padding-right: 20px;
            color: #fff;
            position: relative;
            &.active {
              background-color: #3b664a;
            }
            button {
              padding: 0;
              background-color: rgb(138, 138, 138);
              border-radius: 20px;
              width: 36px;
              height: 36px;
              border-radius: 50%;
              outline: none;
              border: none;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 20px;

              img {
                height: 34px;
                width: 34px;
                object-fit: cover;
                border-radius: 50%;
              }
            }
            &:last-child {
              margin-right: 0;
            }
            .carpet-down {
              width: 20px;
              position: absolute;
              top: 50%;
              right: 0;
              transform: translate(0%, -50%);
            }
            .sub {
              position: absolute;
              bottom: -6px;
              left: -3px;
              z-index: 10000;
              background-color: #fff;
              > ul li {
                display: none;
              }
              &.active > ul li {
                display: block;
              }
              ul {
                position: fixed;
                border-radius: 4px;
                width: 200px;
                background-color: #fff;
                color: #000;
                padding-left: 0px;
                overflow: hidden;
                li {
                  list-style: none;
                  position: relative;
                  &:hover {
                    background-color: #8f8f8f1a;
                    color: #000;
                  }
                  .accordion-button {
                    padding: 4px 8px 4px 8px;
                    &:hover {
                      color: #000 !important;
                    }
                    &::after {
                      background-size: 16px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  dialog {
    width: 400px;
    padding: 0 !important;
    border: none;
    &.hide {
      animation: hide 0.5s ease normal !important;
    }
    &[open] {
      animation: show 0.5s ease normal;
    }
    &:not([open]) {
      display: none !important;
    }
    &::backdrop {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.2);
      animation: none;
    }
    .dialog-header {
      height: 46px;
      background-color: #2c2c2c;
      position: relative;
      h4 {
        color: #fff;
        text-align: center;
        font-size: 16px;
        margin-bottom: 0;
        line-height: 46px;
      }
      img {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
      }
    }
    .dialog-body {
      .accordion-item {
        border: none;
        &:first-of-type .accordion-button {
          height: 53px;
          border-top-left-radius: unset;
          border-top-right-radius: unset;
        }
      }
      .accordion-button:not(.collapsed) {
        color: unset !important;
        background-color: unset !important;
      }
      .accordion-button:focus {
        border-color: unset !important;
        box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
      }
      .accordion-button.collapsed:focus {
        box-shadow: inset 0 -1px 0 rgb(255 255 255 / 13%) !important;
      }
      .accordion-button:not(.collapsed)::after {
        filter: grayscale(1);
      }
    }
    .dialog-footer {
      display: flex;
      flex-direction: column;
      .actions {
        margin: 0 auto;
        margin-bottom: 18px;
      }
      span {
        align-self: flex-end;
        display: inline-block;
        margin-right: 14px;
        cursor: pointer;
        border-bottom: 1px solid #fff;
        &:hover {
          border-bottom: 1px solid #000;
        }
        img {
          transform: translateY(-2px);
        }
      }
    }
  }
}

@keyframes show {
  from {
    opacity: 0;
    transform: translateX(-200px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes hide {
  from {
    opacity: 1;
    transform: translateX(0px);
  }
  to {
    opacity: 0;
    transform: translateX(400px);
  }
}

@media screen and (max-width: 1660px) and (min-width: 1280px) {
  .top,
  .bottom {
    padding: 0 80px;
    .all {
      width: 160px;
      padding: 16px 10px !important;
      img {
        margin-right: 0 !important;
      }
    }
    .categories {
      width: 1040px;
      flex-wrap: nowrap;
      overflow: scroll;
      ::-webkit-scrollbar {
        display: none !important;
      }
      .category {
        white-space: nowrap;
      }
    }
  }
}

@media screen and (max-width: 1279px) and (min-width: 769px) {
  .top,
  .bottom {
    padding: 0 60px;
    .scroller {
      position: relative;
      .all {
        width: 177px;
        padding: 10px 10px !important;
        img {
          margin-right: 0 !important;
        }
      }
      .paddle {
        display: block !important;
        &.left {
          left: -26px;
        }
      }
      .categories {
        width: 624px;
        flex-wrap: nowrap;
        overflow: hidden;
        ::-webkit-scrollbar {
          display: none !important;
        }
        .category {
          white-space: nowrap;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) and (min-width: 481px) {
  .top,
  .bottom {
    padding: 0 25px;
  }
  .scroller {
    position: relative;
    .all {
      width: 180px;
      padding: 10px 10px !important;
      img {
        margin-right: 0 !important;
      }
    }
    .paddle {
      display: block !important;
    }
    .categories {
      width: 416px;
      flex-wrap: nowrap;
      overflow: hidden;
      ::-webkit-scrollbar {
        display: none !important;
      }
      .category {
        white-space: nowrap;
      }
    }
  }
}

@media screen and (max-width: 480px) and (min-width: 0) {
  .top,
  .bottom {
    padding: 0 15px;
  }
  .top {
    padding-top: 20px;
    align-items: baseline !important;

    .brand span {
      font-size: 40px !important;
    }
  }
  .bottom {
    height: 470px !important;
    .wrapper {
      h1 {
        font-size: 26px !important;
      }
      .filter {
        flex-direction: column;
        input {
          width: 100% !important;
          margin-bottom: 20px;
        }
        > img {
          top: 14% !important;
        }
        button {
          justify-content: center;
        }
      }
      .scroller {
        flex-direction: column;
        position: relative;
        .all {
          width: 100%;
          text-align: center;
          margin-bottom: 15px;
        }
        .divider {
          display: none;
        }
        .paddle {
          display: block !important;
          &.left {
            left: -26px !important;
          }
        }
        .categories {
          width: 208px;
          flex-wrap: nowrap;
          overflow: scroll;
          ::-webkit-scrollbar {
            display: none !important;
          }
          .category {
            white-space: nowrap;
            &:not(.sub) {
              justify-content: center;
            }
          }
        }
      }
    }
  }
}
</style>
